import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import ScheduleEF from './ScheduleEF';
import ScheduleEFView from './ScheduleEFView';
import ScheduleEFForm from './ScheduleEFForm';

storiesOf('Case Menu/Schedule Forms/EF', module)
  .add('Loading', () => (
    <div>
      <h3>Component can be in a loading state while we fetch data</h3>
      <hr/>
      <ScheduleEF loading={ true } />
    </div>
  ))

  .add('View', () => (
    <div>
      <h3>By default, we show a view form with search fields</h3>
      <hr/>

      <ScheduleEF
        canEdit={false}
        onSaveSchedule={ action('onSaveSchedule') }
        schedule_ef={sampleScheduleEFWithData}
      />
    </div>
  ))

  .add('View without data', () => (
    <div>
      <h3>Before data is entered, we should display the empty message that server sends</h3>
      <hr/>

      <ScheduleEF
        canEdit={false}
        onSaveSchedule={ action('onSaveSchedule') }
        schedule_ef={sampleScheduleEFEmpty}
      />
    </div>
  ))

  .add('View (Editable)', () => (
    <div>
      <h4>When allowed to, we show the edit button.</h4>
      <h4>Clicking the edit button should bring up the editor form</h4>
      <h4>Saving in the editor results in <code>onSaveSchedule</code> being called with new data</h4>
      <h4>(initial data below is when no data is entered yet, but edit should form even when there is data)</h4>
      <hr/>

      <ScheduleEF
        canEdit={true}
        onSaveSchedule={ action('onSaveSchedule') }
        schedule_ef={sampleScheduleEFEmpty}
      />
    </div>
  ))

  .add('E/F Editor Form', () => (
    <div>
      <h3>Editor form contains buttons to add / remove priority and non-priority creditors</h3>
      <h4>It emits <code>onSubmit</code> and <code>onCancel</code> events</h4>
      <h4>It should ask for confirmation when:</h4>
      <ul>
        <li>removing a creditor</li>
        <li>cancelling a form that has edits</li>
      </ul>
      <hr/>
      <ScheduleEFForm
        onSubmit={ action('onSubmit') }
        onCancel={ action('onCancel') }
        data={sampleScheduleEFWithData.data}
      />
    </div>
  ))

const sampleScheduleEFEmpty = {
  empty: 'There is no Schedule EF for this case.'
}


const sampleScheduleEFWithData = {
  data: {
    priority_creditors: [
      {
        "basis_claim": "Taxes NOTICE",
        "creditor": "IRS\nP.O. Box 7346\nPhiladelphia, PA 19101",
        "debt_date": "",
        "is_contingent": "",
        "is_disputed": "",
        "is_subject_to_offset": "",
        "is_unliquidated": "",
        "priority_amount": "12000.00",
        "total_claim": "0.00"
      },
    ],
      non_priority_creditors: [
      {
        "basis_claim": "accounting work",
        "creditor": "Buchanan's Accounting & Tax Service\n537 Royal Palm Beach Blvd.\nWest Palm Beach, FL 33411",
        "debt_date": "various",
        "is_contingent": "",
        "is_disputed": "",
        "is_subject_to_offset": "",
        "is_unliquidated": "",
        "priority_amount": "",
        "total_claim": "$990.00"
      },
      {
        "basis_claim": "Repairs - 5.30.17 $2,033.04, 7.5.2017 $930.64, 1.12.17 $875.65,7.18.16 $285.00",
        "creditor": "Commerical Truck Repair\n837 West 13th Street\nWest Palm Beach, FL 33404",
        "debt_date": "various",
        "is_contingent": "",
        "is_disputed": "",
        "is_subject_to_offset": "",
        "is_unliquidated": "",
        "priority_amount": "",
        "total_claim": "$4,124.33"
      },
      {
        "basis_claim": "loans to company",
        "creditor": "Ernest Burrs Jr\n2642 West 28th Street\nRivera Beach, FL 33404",
        "debt_date": "",
        "is_contingent": "",
        "is_disputed": "",
        "is_subject_to_offset": "",
        "is_unliquidated": "",
        "priority_amount": "",
        "total_claim": "Unknown"
      }
    ]
  }
}




/** WEBPACK FOOTER **
 ** ./src/scheduleform/ScheduleEF.stories.jsx
 **/